import { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  hoverImage1,
  hoverImage2,
  hoverImage3,
  hoverImage4,
  hoverImage5,
} from "../../../assets";

function HoverInfoSection() {
  const { t } = useTranslation();
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  const [imageSrc, setImageSrc] = useState(hoverImage1);
  const [opacity, setOpacity] = useState(1);

  const images = useMemo(
    () => [hoverImage1, hoverImage2, hoverImage3, hoverImage4, hoverImage5],
    []
  );

  const [activeDiv, setActiveDiv] = useState("0");
  const therapyKeys = ["hypnotherapy", "awareness", "breathing", "eft", "solution"];

  useEffect(() => {
    if (hoveredCard !== null) {
      setOpacity(0);
      const timeoutId = setTimeout(() => {
        setImageSrc(images[hoveredCard]);
        setOpacity(1);
      }, 350);

      return () => clearTimeout(timeoutId);
    }
  }, [hoveredCard, images]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveDiv((prevDiv) => {
        const nextDiv = (parseInt(prevDiv, 10) + 1) % images.length;
        setHoveredCard(nextDiv);
        return nextDiv.toString();
      });
    }, 4000);

    return () => clearInterval(intervalId);
  }, [images.length]);

  return (
    <div className="bg-black relative">
      <section id="hoverinfo">
        <div className="hover-info grid pt-32 mx-auto grid-cols-1 md:grid-cols-2 w-[90%] md:w-[75%] text-white">
          <div className="hover-info-text">
            <div className="hover-info-head">
              <h1 className="text-4xl font-euclid text-customGray">{t("therapyOptions")}</h1>
            </div>
            <div className="hover-info-box-container">
              {["0", "1", "2", "3", "4"].map((divIndex) => (
                <div
                  key={divIndex}
                  onClick={() => setActiveDiv(divIndex)}
                  tabIndex={0}
                  className={`hover-info-box w-[100%] shadow-custom-4-sided rounded-lg transition-all delay-600 shadow-customPurple/70 my-4 p-3 cursor-pointer ${
                    activeDiv === divIndex ? "bg-customPurple-light/80" : "bg-none"
                  }`}
                  onFocus={() => setHoveredCard(parseInt(divIndex, 10))}
                  onBlur={() => setHoveredCard(null)}
                >
                  <div className="hover-info-box-title text-customGray text-xl">
                    {t(`therapy.${therapyKeys[parseInt(divIndex, 10)]}.title`)}
                  </div>
                  <p className="leading-1">{t(`therapy.${therapyKeys[parseInt(divIndex, 10)]}.description`)}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="hover-info-image-container my-auto">
            <div className="hover-info-image">
              <img
                src={imageSrc}
                alt="Hover effect"
                className="mx-auto hidden sm:block md:h-[80vh] transition-opacity duration-500"
                style={{ opacity: opacity }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HoverInfoSection;
